module.exports = __webpack_public_path__ + "static/media/aff.1c67ab93.png";